import { IconFont } from '@/components/IconFont';
import { Dropdown, message, Modal } from 'antd';
import React from 'react';
import { useNodesInteractions } from '../../hooks/use-nodes-interactions';
import { useWorkflowReadOnly } from '../../hooks';
import { cn } from '@/utils';
const MoreBtn: React.FC<{ nodeId: string }> = ({ nodeId }) => {
  const { handleNodeDelete, handleNodeSelect } = useNodesInteractions();
  const { nodesReadOnly } = useWorkflowReadOnly();
  return (
    <Dropdown
      placement="topLeft"
      className={cn({ hidden: nodesReadOnly })}
      menu={{
        items: [
          {
            key: 'edit',
            label: '编辑',
            icon: <IconFont type="icon-gaixie" />,
            onClick: (e) => {
              e.domEvent.stopPropagation();
              handleNodeSelect({ nodeId });
            },
          },
          {
            key: 'delete',
            label: <span className="text-[#FF0000]">删除</span>,
            icon: <IconFont type="icon-shanchu1" className="text-[#FF0000]" />,
            onClick: (e) => {
              e.domEvent.stopPropagation();
              // const { promise, resolve } = createPromise();
              Modal.confirm({
                title: '确认删除此节点吗？',
                content: '删除后，此节点不可找回',
                okText: '删除',
                icon: <IconFont type="icon-shibai" />,
                okButtonProps: {
                  danger: true,
                },
                onOk: () => {
                  handleNodeDelete(nodeId);
                  message.success('删除节点成功');
                },
              });
            },
          },
        ],
      }}
    >
      {/* <MoreOutlined /> */}
      <IconFont type="icon-gengduo1" />
    </Dropdown>
  );
};

export default MoreBtn;
